
import { IActivityModel } from 'src/Entities/Activity/Activity';
import Activity from 'src/Pages/CoursePortal/Activityies/Activity';
import * as Fuse from 'fuse.js'


export class ActivitySearchHelper {
    
    
    public static ActivitySearch(searchQuery: string, activities:ReadonlyArray<IActivityModel>): IActivityModel[]{
        const fuseOption :Fuse.FuseOptions<IActivityModel> = {
            threshold: 0.3,
            // location: 1,
            tokenize: true,
            keys: ["description","courseTitle","teaserText","fiuNo"]
        }
        const fuseObj = new Fuse<IActivityModel>(activities,fuseOption )
        
        return fuseObj.search(searchQuery)
    }
}


// WEBPACK FOOTER //
// ./src/helpers/SearchHelper.ts